module.exports = __webpack_public_path__ + "static/Diasoft-36eeb02745c9b11299e40af091384965.svg";